import { render, staticRenderFns } from "./PaysLogs.vue?vue&type=template&id=33cb9c4c&scoped=true&"
import script from "./PaysLogs.vue?vue&type=script&lang=js&"
export * from "./PaysLogs.vue?vue&type=script&lang=js&"
import style0 from "./PaysLogs.vue?vue&type=style&index=0&id=33cb9c4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33cb9c4c",
  null
  
)

export default component.exports